// extracted by mini-css-extract-plugin
export default {"goldDiamond":"_eb48f90c","platinumDiamond":"_bede261a","icon":"_52dc54a3","wrapper":"_a7b4a97b","tooltipLink":"_99b1a8fd"};